<script>
  export let data = { form: { value: '' } },
    contact;

  const value = data.form?.value || '';
</script>

<div class="activity-form-input">
  {@html value}
</div>
